import { APP_NAME } from "@constants/app.constants";
import PromoCodeCreateComponent from "@screens/promo-code/promo-code-create/promo-code-create.component";
import PromoCodeEditComponent from "@screens/promo-code/promo-code-edit/promo-code-edit.component";
import PromoCodeListComponent from "@screens/promo-code/promo-code-list/promo-code-list.component";

const promoCodeRoutes = [
  {
    name: `Promo Code - ${APP_NAME}`,
    path: "/promo-code",
    icon: "layout",
    component: PromoCodeListComponent,
  },
  {
    name: `Create Promo Code - ${APP_NAME}`,
    path: "/promo-code/create",
    component: PromoCodeCreateComponent,
  },
  {
    name: `Edit Promo Code - ${APP_NAME}`,
    path: "/promo-code/edit",    
    component: PromoCodeEditComponent,
  },
];

export default promoCodeRoutes;
